import React from "react";
import { Tag, Popover, Table } from "antd";

export const TagFirmado = ({ formulario, color, className, children }) => {

    const columnas = [
        {
            title: 'Fecha Firma',
            dataIndex: 'fechaFirma',
            key: 'fechaFirma',
            align: 'center'
        },
        {
            title: 'Plataforma',
            dataIndex: 'plataforma',
            key: 'plataforma',
            align: 'center'
        },
    ];

    const historial = [
        {
            key: '1',
            fechaFirma: formulario.fechaFirma,
            plataforma: formulario.plataformaFirma
        }
    ];

    const datosVisualizacion = (
        <div>
            <Table dataSource={historial} columns={columnas} pagination={false} />
        </div>
    );

    return (
        <Popover content={datosVisualizacion} placement="bottom" trigger="click">
            <Tag color={color} className={className}>{children}</Tag>
        </Popover>
    )
}
